import { Button } from "./button";

export const Result = ({ reset, result }: { reset: () => void, result: string }) => {
  const resultData = {
    best: {
      title: "BEST",
      content: "These are the sort of people you should actively seek to find. These people are wonderful people and your life and work are better for having them in your life. Collaborate with them. Enjoy their company."
    },
    better: {
      title: "BETTER",
      content: "Great to speak to, but you don't really trust them when it comes to important tasks. Trust cautiously."
    },
    trustworthy: {
      title: "TRUSTWORTHY",
      content: "These people are no fun but they make the world a better place - for puppies, especially."
    },
    limit: {
      title: "LIMIT",
      content: "Avoid at all costs. It's obvious that you don't trust them."
    }
  };

  const currentResult = resultData[result as keyof typeof resultData];

  return (
    <div className="step-container">
      <div className="content-card result-card">
        <h2 className={`result-title ${result}`}>{currentResult.title}</h2>
        <p className="result-content">{currentResult.content}</p>
        <Button className="reset-button" onClick={reset} label="Start Over" />
      </div>
    </div>
  );
}
